var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"topicBg"},[_c('span',{staticClass:"leftBg"}),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"rightBg"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }